import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

export const sentryServiceInit = (dsn) => {
  Sentry.init({
    Vue,
    dsn: dsn,
    autoSessionTracking: true,
    environment: process.env.VUE_APP_ENV,
    release: `qualification-module@${process.env.VUE_APP_RELEASE}`,
    integrations: [
      new Integrations.BrowserTracing()
    ],
    tracingOptions: {
      trackComponents: true
    },

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  });
};

export const sentryServiceSetTag = (key, value) => {
  Sentry.setTag(key, value);
};

export const sentryServiceSetContext = (name, obj) => {
  Sentry.setContext(name, obj);
};

export const sentryServiceClearContext = () => {
  Sentry.configureScope(scope => scope.clear());
};
